import { gql } from "@apollo/client"

const CREATE_VIDEO_CONFERENCE_MUTATION = gql`
  mutation($input: CreateVideoConferenceInput!) {
    createVideoConference(input: $input) {
      token
    }
  }
`

export default CREATE_VIDEO_CONFERENCE_MUTATION
